import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import type { Nullable } from 'corgi-types';
import type { BorderRadiusProps, BorderTopProps, ColorProps } from 'styled-system';
import { borderRadius, borderTop, color } from 'styled-system';

import { getForwardPropOpts } from '../../theme/helpers/forward-props';
import type { BoxSizingProps } from '../../theme/system-utilities';
import { boxSizing } from '../../theme/system-utilities';
import type { FlexProps } from '../Flex';
import { Flex } from '../Flex';

export const enum GradientBlockType {
  Horizontal = 'to right',
  Vertical = 'to bottom',
}

interface GradientBlockProps {
  startColor: Nullable<string>;
  endColor: Nullable<string>;
  type?: GradientBlockType;
}

const UnstyledGradientBlock = styled(Flex, getForwardPropOpts(['color', 'type']))<
  GradientBlockProps & FlexProps & BoxSizingProps & ColorProps & BorderTopProps & BorderRadiusProps
>`
  ${boxSizing};
  ${color};
  ${borderTop};
  ${borderRadius};

  ${({ startColor, endColor, type }) =>
    startColor &&
    endColor &&
    `background-image: linear-gradient(${type}, ${startColor}, ${endColor});`}
  ${({ startColor }) => startColor && `background-color: ${startColor};`}
`;

const GradientBlock = (props: ComponentProps<typeof UnstyledGradientBlock>) => (
  <UnstyledGradientBlock
    type={GradientBlockType.Horizontal}
    boxSizing="border-box"
    width="100%"
    bg="sys.neutral.background.weaker"
    {...props}
  />
);

export default GradientBlock;
